import { ConsentStoreInitialState } from "../types/store/consent"
import { action, makeObservable, observable } from "mobx"

export class ConsentStore {
  consentGroups: string[] = []

  constructor(initialState: ConsentStoreInitialState) {
    this.consentGroups = initialState?.consentGroups || ''

    makeObservable(this, {
      consentGroups: observable,
      updateConsentGroups: action.bound,
      hasMarketingConsent: action.bound
    })
  }

  updateConsentGroups(groups: string[]) {
    this.consentGroups = groups
  }

  hasMarketingConsent(): boolean {
    return this.consentGroups.includes('C0004')
  }

  get asJson() {
    return {
      consentGroups: this.consentGroups,
      updateConsentGroups: this.updateConsentGroups,
      hasMarketingConsent: this.hasMarketingConsent
    }
  }
}